export const handleUndo = (
    setUndoStack: React.Dispatch<React.SetStateAction<any[]>>,
    setRedoStack: React.Dispatch<React.SetStateAction<any[]>>,
    setData: React.Dispatch<React.SetStateAction<any>>,
    setText: React.Dispatch<React.SetStateAction<any>>,
    undoStack: any[],
    data: any
) => {
    if (undoStack.length === 0) return;

    // Add current state to redo stack
    setRedoStack(prevRedoStack => [data, ...prevRedoStack]);

    const lastState = undoStack[undoStack.length - 1];

    // Remove the last state from the undo stack
    setUndoStack(undoStack.slice(0, undoStack.length - 1));

    setText(lastState.properties.text);
    setData(lastState);
};

export const handleRedo = (
    setUndoStack: React.Dispatch<React.SetStateAction<any[]>>,
    setRedoStack: React.Dispatch<React.SetStateAction<any[]>>,
    setData: React.Dispatch<React.SetStateAction<any>>,
    setText: React.Dispatch<React.SetStateAction<any>>,
    undoStack: any[],
    redoStack: any[],
    data: any
) => {
    if (redoStack.length === 0) return;

    const lastUndoneState = redoStack[0];

    // Move the current state to the undo stack before redoing
    setUndoStack([...undoStack, data]);

    // Remove the first state from redo stack
    setRedoStack(redoStack.slice(1));

    setText(lastUndoneState.properties.text);
    setData(lastUndoneState);
};
